import * as Constants from 'client/util/Constants';
import SoftwareApi from 'client/api/v2/SoftwareApi';
import Vue from 'vue';

const {
  macOS,
  windows,
} = Constants.default;

const ubuntu = 'Ubuntu';

export const createOsReleasesModule = () => ({
  namespaced: true,
  state: {
    osVersionPatchList: [],
  },
  actions: {
    /**
     * We get each OS releases per API request
     */
    async fetchOsReleases({ commit }) {
      const osNames = [windows, macOS, ubuntu];
      const osReleases = {};

      await Promise.all(osNames.map(async (osName) => {
        const filterParameter = {
          osName: osName.replace(/\s+/g, ''),
          limit: 100,
          sort: '-version',
        };
        await SoftwareApi.fetchOsReleases(filterParameter)
          .then((response) => {
            osReleases[osName.replace(/\s+/g, '')] = response.data;
          });
      }));

      commit('SET_STATE', osReleases);
    },
  },
  mutations: {
    SET_STATE(state, payload) {
      Vue.set(state, 'osVersionPatchList', payload);
    },
  },
});

export default createOsReleasesModule();
